export default __webpack_public_path__ + "static/media/kitties-snuggling.abfed3ee.png";